import { Component, input, output } from "@angular/core";

import { SearchService } from "@services/search.service";

@Component({
  selector: "plants-pagination",
  imports: [],
  templateUrl: "./plants-pagination.component.html",
  styleUrl: "./plants-pagination.component.scss"
})
export class PlantsPaginationComponent {
  constructor(private searchService: SearchService) {}
  page = input.required<number>();
  totalPages = input.required<number>();
  pageChange = output<number>();

  onPageChange(page: number) {
    this.pageChange.emit(page);
  }

  get startPage() {
    return this.searchService.startPage;
  }

  get endPage() {
    return this.searchService.endPage;
  }
}
